<template>
  <div class="create-new-client-component">
    <v-loader v-show="isLoading" absolute />
    <v-snackbar v-model="showSnackbar" top color="red" timeout="1000">
      <span>{{ errorMessage }}</span>
    </v-snackbar>
    <h1 class="font-weight-regular">
      Информация о клиенте:
    </h1>

    <div class="button-group d-flex justify-between">
      <v-row class="justify-space-between">
        <v-col sm="5">
          <v-btn to="/orders" class="button button-back" width="100%" color="#F1F3F6">
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="user-info-section">
      <div class="user-phone">
        <v-row>
          <v-col>
            <span class="label">Телефон:</span>
            <v-text-field
              @focus="showPhoneKeyboard = true"
              v-model="phone"
              hide-details="auto"
              class="text-field"
              disabled
              flat
              solo
            />
          </v-col>
          <v-col>
            <span class="label">Имя:</span>
            <v-text-field
              @focus="showPhoneKeyboard = false"
              v-model="name"
              hide-details="auto"
              class="text-field"
              disabled
              flat
              solo
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import VLoader from '@/components/loader/Loader'

  export default {
    name: 'CreateClient',
    components: {
      VLoader,
    },
    data () {
      return {
        showSnackbar: false,
        isLoading: false,
        name: '',
        phone: '',
        errorMessage: '',
        gender: 'FEMALE',
        suggests: [],
        showPhoneKeyboard: true,
        timeout: null,
      }
    },
    watch: {
      order: {
        handler () {
          this.phone = this.order.client.phone || ''
          this.name = this.order.client.name || ''
        },
        deep: true,
      },
      name () {
        this.getSuggestNames()
      },
      gender () {
        if (this.name) {
          this.getSuggestNames()
        }
      },
    },
    computed: {
      ...mapState({
        order: state => state.fastOrder.currentOrder,
      }),
    },
    methods: {
      getSuggestNames () {
        if (this.name.length > 1) {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            const payload = {
              name: this.name,
              gender: this.gender,
              count: 8,
            }
            this.$store
              .dispatch('suggests/fetchNamesSuggestList', payload)
              .then((res) => {
                if (res.status === 200) {
                  this.suggests = res.data.suggests
                } else {
                  this.suggests = []
                }
              })
          }, 500)
        }
      },
      createAnonymousClient () {
        this.isLoading = true

        this.$store
          .dispatch('clients/createClients', {
            status: true,
          })
          .then((res) => {
            if (res.status === 200) {
              history.pushState({}, null, this.$route.path + `?id=${res.data.id}`)
              this.createBasket(res.data.id)
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      async createClient () {
        const isValid = await this.$refs.validation.validate()
        if (!isValid) return
        this.isLoading = true
        const payload = {
          phone: this.phone.match(/[0-9]/g).join(''),
          name: this.name,
        }
        this.$store
          .dispatch('clients/createClients', payload)
          .then((res) => {
            if (res.status === 200) {
              history.pushState({}, null, this.$route.path + `?id=${res.data.id}`)
              this.createBasket(res.data.id)
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      createBasket (id) {
        this.$store
          .dispatch('baskets/createBasket', { clientId: id })
          .then((res) => {
            if (res.status === 200) {
              // Если корзина создалась - находим ее и добавляем в стор
              this.$store
                .dispatch('baskets/fetchSingleBasket', res.data.id)
                .then((res) => {
                  if (res.status === 200) {
                    this.$store.commit('baskets/setBasket', res.data.data)
                    this.$store.commit('newOrder/setStep', 1)
                  }
                })
            } else {
              console.warn('Error', res)
              this.showSnackbar = true
              this.errorMessage = res.response.data.message
            }
          })
      },
      setName (name) {
        this.name = name
      },
      goStepOne () {
        this.$store.commit('fastOrder/setStep', 1)
      },
    },
    mounted () {
      if (this.order.client) {
        this.phone = this.order.client.phone || ''
        this.name = this.order.client.name || ''
      }
    },
  }
</script>

<style lang="less" scoped>
.create-new-client-component {
  position: relative;
  z-index: 0;
  padding-top: 84px;

  h1 {
    font-size: 34px;
    line-height: 1;
    margin-bottom: 33px;
  }

  .label {
    display: block;
    margin-bottom: 14px;
    font-size: 20px;
    line-height: 21px;
  }

  .button {
    height: 80px;
    border-radius: 10px;

    svg {
      margin-right: 8px;
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    &.error--text {
      ::v-deep {
        .v-input__slot {
          border: 2px solid @color-error;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .button-group {
    margin-bottom: 30px;

    .button {
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;
    }

    .button-back {
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-create {
      color: #ffffff;
      background-color: @color-success !important;

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .user-info-section {
    .button {
      border-radius: 10px !important;
    }

    .user-gender {
      margin-bottom: 22px;

      .gender-buttons {
        flex: 1;

        .button {
          margin-right: 15px;

          &.v-item--active {
            color: #ffffff;
            background-color: @color-primary !important;
            &:before {
              display: none;
            }
          }
        }
      }

      .button {
        max-width: 180px;
        width: 100%;
        font-size: 15px;
        box-shadow: 0 3px 6px #00000029 !important;
      }
    }
  }

  .user-names {
    min-height: 208px;

    .button {
      font-size: 24px;
      line-height: 18px;
    }
  }
}
</style>
